/**
 * Defines constants
 * @namespace Constants
 * 
 * @example
 * import * as Constants from './constants';
 */

/**
 * @namespace Constants
 */

/*export const LOCALHOST_API = 'https://localhost:51342/';*/
export const LOCALHOST_API = 'https://localhost:53968/';
export const  PROD_API = '/api/';
export const ENVIRONMENT_API = (window.location.hostname.indexOf("localhost") < 0 ? PROD_API : LOCALHOST_API);